import { useState, useEffect, useRef } from "react";
import OpenAI from "openai";
import AutoResizingInput from "@components/UI/AutoResizingInput";
import sendLogo from "@img/send.svg";
import Button from "@components/UI/Button";
import aiIcon from "@img/ai.avif";
import { useAuth } from "@/utils/auth-context";
import { app } from "@/firebase/firebaseConfig";
import InvestorModal from "@components/InvestorModal.jsx";
import { getFunctions, httpsCallable } from "firebase/functions";

const AIPage = () => {
  const [messages, setMessages] = useState(() => {
    const savedMessages = sessionStorage.getItem("chat-messages");
    if (savedMessages) {
      return JSON.parse(savedMessages);
    }
    return [
      {
        role: "assistant",
        content:
          "Привет! Можете задать вопрос. Я постараюсь ответить быстро и подробно.",
      },

      {
        role: "assistant",
        content:
          "Я всё быстро забываю — не забудьте сохранить важные ответы у себя!",
      },
    ];
  });

  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const messagesContainerRef = useRef(null);
  const { isVerified } = useAuth();
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop =
        messagesContainerRef.current.scrollHeight;
    }
  }, [messages]);

  const handleSend = async () => {
    if (!input.trim()) return;

    if (!isVerified) return;

    const newMessages = [...messages, { role: "user", content: input }];
    setMessages(newMessages);
    setInput("");

    try {
      setLoading(true);

      const functions = getFunctions(app, "us-central1");
      console.log("2. Functions instance created");

      const chatFunction = httpsCallable(functions, "chat");
      console.log("3. Chat function created");

      const result = await chatFunction({
        messages: [
          {
            role: "system",
            content:
              "Тебя зовут Эндрю. Ты помогаешь придумывать названия и писать описания для товаров на Amazon, а также отвечаешь на вопросы о продажах на Amazon.",
          },
          ...newMessages.map((msg) => ({
            role: msg.role,
            content: msg.content,
          })),
        ],
      });

      const botReply = result.data.message.content;

      setMessages((prev) => [
        ...prev,
        { role: "assistant", content: botReply },
      ]);
      setLoading(false);
    } catch (error) {
      console.error("Ошибка отправки запроса:", error);
    }
  };

  useEffect(() => {
    sessionStorage.setItem("chat-messages", JSON.stringify(messages));
  }, [messages]);

  const handleKeyDown = (e) => {
    if (!isVerified) return;

    if (e.key === "Enter") {
      if (e.shiftKey) {
        e.preventDefault();
        const textarea = e.target;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;

        textarea.value =
          textarea.value.substring(0, start) +
          "\n" +
          textarea.value.substring(end);

        textarea.selectionStart = textarea.selectionEnd = start + 1;
      } else {
        e.preventDefault();
        handleSend();
      }
    }
  };

  const containerRef = useRef(null);

  return (
    <div
      onClick={() => setOpenModal(true)}
      ref={containerRef}
      className="layout layout--dark chat chat--dark"
    >
      {openModal && !isVerified && (
        <InvestorModal
          text={`Доступ временно закрыт`}
          closeModal={() => setOpenModal(false)}
        />
      )}
      <div className="chat-main chat-main--dark">
        <div className={`chat-header`}>
          <img
            className={`chat-header__avatar chat-header__avatar--ai`}
            src={aiIcon}
            alt={`ai-icon`}
            width={40}
          />
          <div className={`chat-header-status`}>
            Эндрю - Ваш куратор {loading ? "печатает..." : "🟢"}
            <p className={`chat-header-status__subtitle `}>
              Привет! Я Эндрю. <br />
              Если есть вопросы - можете задавать. Я обычно отвечаю в течение 1
              минуты.
            </p>
          </div>
        </div>
        <div className="chat-body chat-body--dark">
          <div className="chat-messages" ref={messagesContainerRef}>
            {messages.map((msg, index) => {
              const isUser = msg.role === "user";
              return (
                <div
                  key={index}
                  className={`chat-message-box
                    ${isUser ? " chat-message-box--right" : "chat-message-box--left "}
                  `}
                  style={{ marginBottom: 8 }}
                >
                  <p
                    className={`chat-message ${isUser ? "chat-message--right" : "chat-message--left"} `}
                  >
                    {msg.content}
                  </p>
                  {!isUser && (
                    <div className={`chat-message__avatar`}>
                      <img src={aiIcon} alt="ai-icon" width={30} />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          <div className="chat-input">
            <AutoResizingInput
              message={input}
              setMessage={setInput}
              handleKeyDown={handleKeyDown}
            />

            <Button
              disabled={loading}
              image={loading ? "" : sendLogo}
              color="blue"
              onClick={handleSend}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIPage;
